import * as contentful from 'contentful'
import config from '@/config'

const client = contentful.createClient({
  space: config.contentful.space,
  accessToken: config.contentful.accessToken
})

export default client
